import isNil from "lodash-es/isNil";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { history, isWechat_iOS } from "./utils";

import "weui";
import "./index.css";

// NOTE: 微信 JSSDK 调用报错 the permission value is offline verifying
//  问题分析: 导致此问题的原因是计算签名使用的 url 与微信中的 url 不符. 正常情况下使用 location.href 获取到的 url 即可,
//  但是, 针对使用 history 模式的 Vue 应用(其它 SPA 应用应该都存在此问题), 微信在 iOS 和 Android 下的反应不一样, Android
//  下使用 location.href 获取到的 url 没有问题, 但是 iOS 下就会报以上错误, 这是由于 iOS 微信中, Vue 切换页面时, 虽然
//  location.href 值变了, 但是微信仍然会用第一次进入页面的地址来验证.
//  解决方法: 针对此问题, 对 iOS 和 Android 分开处理即可, 当为 Android 时直接使用 location.href 签名, 当为 iOS 时改为使用
//  第一次进入地址进行签名. 通过 window.__wxjs_is_wkwebview 可以判断是 iOS 或 Android
if (isWechat_iOS() && isNil(window.entryUrl)) {
  window.entryUrl = window.location.href;
}

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <HistoryRouter basename={ baseUrl } history={ history }>
    <App />
  </HistoryRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
